<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData"  ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号">
           {{ formData.plateNumber||'--' }}
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driver" label="司机姓名">
              {{ formData.driver||'--' }}

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverPhone" label="司机手机">
              {{ formData.driverPhone||'--' }}

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="outTime" label="外出时间">
              {{ formData.outTime||'--' }}

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="returnTime" label="回厂时间">
              {{ formData.returnTime||'--' }}

          </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="reason" label="外出原因">
              {{ formData.reason||'--' }}

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="approveResult" label="审批结果">
              <el-tag type="success" v-if="formData.approveResult == '1'">待审批</el-tag>
            <el-tag   v-if="formData.approveResult == '2'">审批通过</el-tag>
            <el-tag type="danger" v-if="formData.approveResult == '3'">审批驳回</el-tag>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="approveComment" label="审批意见">
              {{ formData.approveComment||'--' }}

          </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap" v-if="$attachmentFiles(formData.fileList).length>0">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

              </div>
              <div v-else class="empty">暂无</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'vehicleAccessDetail',

  data () {
    return {
      formData: {
        outTime: '',
        returnTime: '',
        plateNumber: '',
        driver: '',
        driverPhone: '',
        reason: '',
        fileList: []
      },

      loading: false

    }
  },
  created () {
    if (this.recordId) {
      this.loadData()
    }
  },
  computed: {
    recordId () {
      return this.$route.query.recordId
    },
    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.vehicleAccess.selectPaVehicleOutByRecordId, {
          params: { recordId: this.recordId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },

    delImage (index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          const url = this.$apis.vehicleAccess.insertPaVehicleOut
          // if (this.recordId) {
          //   url = this.$apis.vehicleAccess.updatePaVehicleInfo
          // }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

}
.empty{
  color: #999;
}
</style>
